import { Group } from '../../components/types';

interface UseGroupsManagementProps {
  groups: Group[];
  setGroups: (groups: Group[]) => void;
  saveToHistory: () => void;
  generateId: () => string;
}

export function useGroupsManagement({
  groups,
  setGroups,
  saveToHistory,
  generateId,
}: UseGroupsManagementProps) {
  const addGroup = (insertIndex?: number) => {
    saveToHistory();
    const newGroup: Group = {
      id: generateId(),
      name: 'Novo Grupo',
      order: insertIndex !== undefined ? insertIndex : groups.length,
      sections: [],
    };

    let updatedGroups: Group[];
    if (insertIndex !== undefined) {
      updatedGroups = [...groups];
      updatedGroups.splice(insertIndex, 0, newGroup);
      updatedGroups = updatedGroups.map((g, idx) => ({ ...g, order: idx }));
    } else {
      updatedGroups = [...groups, newGroup];
    }

    setGroups(updatedGroups);
  };

  const editGroup = (groupId: string, name: string) => {
    saveToHistory();
    setGroups(
      groups.map((group) => (group.id === groupId ? { ...group, name } : group))
    );
  };

  const removeGroup = (groupId: string) => {
    saveToHistory();
    const filteredGroups = groups.filter((group) => group.id !== groupId);
    setGroups(
      filteredGroups.map((group, index) => ({
        ...group,
        order: index,
      }))
    );
  };

  const duplicateGroup = (groupId: string) => {
    saveToHistory();
    const groupToDuplicate = groups.find((g) => g.id === groupId);
    if (!groupToDuplicate) return;

    const duplicatedGroup: Group = {
      ...JSON.parse(JSON.stringify(groupToDuplicate)),
      id: generateId(),
      name: `${groupToDuplicate.name} (Cópia)`,
      order: groups.length,
      sections: groupToDuplicate.sections.map((section, sectionIndex) => ({
        ...section,
        id: generateId(),
        order: sectionIndex,
        questions: section.questions.map((question, questionIndex) => ({
          ...question,
          id: generateId(),
          order: questionIndex,
        })),
      })),
    };

    setGroups([...groups, duplicatedGroup]);
  };

  return {
    addGroup,
    editGroup,
    removeGroup,
    duplicateGroup,
  };
}
